// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const personsExportFields = [
  {
    titleIntlKey: "persons.columns.person.title",
    fields: [
      "personId",
      "forcePersonId",
      "externalId",
      "gender",
      "dob",
      "deceased",
      "languageLocal",
      "nationality",
      "representing",
      "status",
      "nameAbbreviated",
      "nameFamilyLatin",
      "nameFamilyLocal",
      "nameFullLatin",
      "nameFullLocal",
      "nameGivenLatin",
      "nameGivenLocal",
    ],
  },
  {
    titleIntlKey: "persons.columns.additionalDetails.title",
    fields: [
      "additionalDetailsCollege",
      "additionalDetailsCollegeClass",
      "additionalDetailsDominantFoot",
      "additionalDetailsDominantHand",
      "additionalDetailsHeight",
      "additionalDetailsHeightImperial",
      "additionalDetailsHomeTown",
      "additionalDetailsJuniorAssociationLeague",
      "additionalDetailsRepresentation",
      "additionalDetailsSchool",
      "additionalDetailsSchoolClass",
      "additionalDetailsWeight",
      "additionalDetailsWeightImperial",
    ],
  },
  {
    titleIntlKey: "persons.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultPersonsExportFieldNames = ["personId", "gender", "dob", "nationality", "status", "nameFullLocal"];
